import { getClubBanner } from '../clubBanners'
import type { PLTableEntry } from '../types'
import { teamDisplayName } from '../teams'
import PageHeader from './PageHeader'
import './PLPage.css'

interface PLPageProps {
  plTable: PLTableEntry[]
}

/** Goal difference reads signed — `+12`, `0`, `-7`. Zero carries no sign. */
function formatGoalDifference(goalDifference: number): string {
  return goalDifference > 0 ? `+${goalDifference}` : String(goalDifference)
}

function PLPage({ plTable }: PLPageProps) {
  // The drop zone is derived from the table's own length, not a hardcoded 18, so a short
  // fixture behaves like a 20-club season. It stays off before a ball is kicked: the
  // pre-season fallback is alphabetical and level on zero points, so it has no bottom three.
  const seasonUnderway = plTable.some((entry) => entry.played > 0)
  const dropZoneFrom = plTable.length - 3

  return (
    <div className="pl-page">
      <PageHeader title="Premier League" />
      <div className="pl-page__table section-flush">
        <div className="pl-page__table-header">
          <div className="pl-page__table-left" />
          <div className="pl-page__table-stats">
            <span className="pl-page__table-stat">P</span>
            <span className="pl-page__table-stat">GD</span>
            <span className="pl-page__table-stat">Pts</span>
          </div>
        </div>
        {plTable.map((entry) => {
          const inDropZone = seasonUnderway && entry.position > dropZoneFrom

          return (
            <div
              key={entry.team}
              className={`pl-page__table-row${inDropZone ? ' pl-page__table-row--drop' : ''}`}
            >
              <div className="pl-page__table-left">
                <span className="pl-page__table-position">{entry.position}</span>
                {getClubBanner(entry.team) && (
                  <img
                    className="pl-page__table-banner"
                    src={getClubBanner(entry.team)}
                    alt=""
                    aria-hidden="true"
                  />
                )}
                <span className="pl-page__table-team">{teamDisplayName(entry.team)}</span>
              </div>
              <div className="pl-page__table-stats">
                <span className="pl-page__table-stat">{entry.played}</span>
                <span className="pl-page__table-stat">
                  {formatGoalDifference(entry.goalDifference)}
                </span>
                <span className="pl-page__table-stat pl-page__table-stat--points">
                  {entry.points}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default PLPage
